<script>
    import {createEventDispatcher} from 'svelte';
    import {onMount} from 'svelte';
    import {CustomInput} from 'sveltestrap';
    
    const dispatch = createEventDispatcher();

    export let columns = [];

    let previousColumString = "";

    export let isShown = false;
    export function showModal() {
        isShown = true;
    }

    let modalCloseAction = () => {
        isShown = false;
		dispatch('close');
	};

    function handleColumnVisibility(){
        columns.forEach(col => {
            let value = localStorage.getItem(col.name);
            if(value == "true" || value == null){
                col.checked = true;
            }
            else{
                col.checked = false;
            }
        });
    }

    function toggleColumnVisibility(column){
        column.checked = !column.checked;
        localStorage.setItem(column.name, column.checked);
    }

    onMount(() => {
        previousColumString = JSON.stringify(columns);
        console.log(previousColumString);
        handleColumnVisibility();
    })
</script>

{#if isShown}
    <div class="popup-modal" role="dialog" aria-modal="true">
        <div class="header d-flex justify-content-center">
            <h4 class="font-weight-bold text-primary mr-auto">Endpoint Column Settings</h4>
            <button class="ml-auto pointer bg-transparent rounded-circle border-0" on:click={() => modalCloseAction()}>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                    <path d="M18 6.74518L6 18.7452" stroke="#4664A0" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M6 6.74518L18 18.7452" stroke="#4664A0" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </button>
            
        </div>
        <div class="modal-content">
            {#each columns as column}
                {#if column.name != "Endpoint Name"}
                    <div class="m-2">
                        <CustomInput type="switch" id={column.name} label={column.name} checked={column.checked} on:change={() => toggleColumnVisibility(column)}></CustomInput>
                    </div>
                {/if}
            {/each}
        </div>
        <div class="footer">
            <div class="button-group m-2 mt-2">
                <button class="btn btn-primary" on:click={() => modalCloseAction()}>Apply</button>
            </div>
        </div>
    </div>
{/if}

<style>
    .popup-modal {
        position: fixed;
        width: calc(100vw - 3em);
        height: 60vh;
        width: 35vw;
        background: var(--card-color);
        z-index: 102;
        animation: slideIn 500ms forwards;
        box-shadow: 0 2px 4px 2px #00aec92a;
        right: 20px;
        top: 30%;
        border-radius: 12px;
        animation: popIn 300ms forwards;
    }

    .popup-modal .header {
        border-radius: 12px 12px 0px 0px;
        font-weight: 600;
        margin-bottom: 0.5em;
        position: sticky;
        padding: 1em;
        top: 0;
        background-color: white;
        box-shadow: 0 2px 4px 2px #00aec92a;
    }

    .popup-modal .footer {
        background-color: white;
        padding: 0.5em;
        position: sticky fixed;
        bottom: 0
    }

    .popup-modal .footer .button-group {
        float: right;
        margin-bottom: 20px;
    }

    .popup-modal .header {
        font-weight: 500
    }

    .popup-modal .footer .button-group {
        float: right;
    }

    .popup-modal .modal-content {
        height: 75%;
        overflow: scroll;
        padding: 1em;
        background: hsl(0 0% 0% / 0.01);
        border: none!important;
    }

@keyframes slideIn {
    from {
        width: 0;
    }

    to {
        width: 42vw;
    }
}

@keyframes slideOut {
    from {
        width: 42vw;
    }

    to {
        width: 0;
    }
}


@keyframes popIn {
    from {
        top: 100%;
    }

    to {
        top: 30%;
    }
}
</style>